"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATEMENT_MAPPING = {
    prefix: 'statements',
    updateFromPcc: {
        path: '/updateFromPCC'
    },
    updateStatements: {
        path: '/updateStatements',
        parameter: '/:batchId'
    },
    updateFacilityStatementsFromPcc: {
        path: '/updateFacilityStatementsFromPcc',
        parameter: '/:facilityId'
    },
    batchList: {
        path: '/batches'
    },
    getBatchById: {
        path: '/getBatchById',
        parameter: '/:batchId'
    },
    deleteBatchById: {
        path: '/deleteBatchById',
        parameter: '/:batchId'
    },
    getStatementById: {
        path: '/getStatementById',
        parameter: '/:statementId'
    },
    getLetterById: {
        path: '/getLetterById',
        parameter: '/:letterId'
    },
    batchStatementList: {
        path: '/batches',
        parameter: '/:batchId'
    },
    changeStatus: {
        path: '/changeStatus',
        parameter: '/:statementId'
    },
    residentStatementList: {
        path: '/residents',
        parameter: '/:residentId'
    },
    fetchBatchStatements: {
        path: '/fetchBatchStatements',
        parameter: '/:batchId'
    },
    fetchFacilitiesStatements: {
        path: '/fetchFacilitiesStatements'
    },
    updateBatch: {
        path: '/updateBatch',
        parameter: '/:chainId'
    },
    createBatch: {
        path: '/createBatch',
        parameter: '/:chainId'
    },
    getStatementMessages: {
        path: '/getStatementMessages',
        parameter: '/:statementId'
    },
    addStatementMessage: {
        path: '/addStatementMessage',
        parameter: '/:statementId'
    },
    regenerateStatement: {
        path: '/regenerateStatement',
        parameter: '/:statementId'
    },
    regenerateLetter: {
        path: '/regenerateLetter',
        parameter: '/:letterId'
    },
    changeStatementMessageActiveState: {
        path: '/changeStatementMessageActiveState',
        parameter: '/:statementMessageId'
    },
    fetchBatchLetters: {
        path: '/fetchBatchLetters',
        parameter: '/:batchId'
    },
    fetchLettersBatchStatistics: {
        path: '/fetchLettersBatchStatistics',
        parameter: '/:batchId'
    }
};
